import { STORE_PHONE, STORE_STATUS_INITIALIZED } from 'constants/store'
import { createGenericSlice, GenericState } from 'stores/generics'

export type SignedTermsState = {
  terms: string[]
}

type State = GenericState<
  SignedTermsState,
  {
    data: string
    error_id: string
  }
>

export const initialState: State = {
  data: {
    terms: [],
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

const userSlice = createGenericSlice({
  name: STORE_PHONE,
  initialState,
  reducers: {},
})

const { actions, reducer } = userSlice

const { clear, success } = actions

export { clear, success }

export default reducer
